import { jsx as _jsx } from "react/jsx-runtime";
export const CopyXs = ({ color, ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8.57715 5.25391C8.95512 5.29253 9.25 5.61183 9.25 6V14C9.25 14.4142 8.91421 14.75 8.5 14.75H2.5C2.08579 14.75 1.75 14.4142 1.75 14L1.75391 5.92285C1.79253 5.54488 2.11183 5.25 2.5 5.25L8.57715 5.25391ZM3.25 13.25H7.75V6.75H3.25V13.25ZM13.0771 1.25391C13.4551 1.29253 13.75 1.61183 13.75 2V10.5C13.75 10.9142 13.4142 11.25 13 11.25H11.25C10.8358 11.25 10.5 10.9142 10.5 10.5C10.5 10.0858 10.8358 9.75 11.25 9.75H12.25V2.75H7.75V3.25C7.75 3.66421 7.41421 4 7 4C6.58579 4 6.25 3.66421 6.25 3.25L6.25391 1.92285C6.29253 1.54488 6.61183 1.25 7 1.25L13.0771 1.25391Z",
            fill: color ?? 'currentColor'
        })
    });

//# sourceMappingURL=copy-xs.js.map